<template>
    <div class="object-picker">
        <div :class="['object-picker__body', `${disabled ? 'disabled' : ''}`]" @click="!disabled && $set(varObj,'visible',true)">
            {{ objectName }}
            <i class="hc-icon-plus icon-more" />
        </div>
        <hc-dialog v-if="varObj.visible && !showAddObject" :visible.sync="varObj.visible && !showAddObject" :title="title" width="560px" append-to-body @close="cancelFn">
            <div v-if="schema || showAddBtn" class="add-btn" @click="addObject">
                <img src="../../../assets/img/btn.svg" class="add-btn-icon" alt="">
                <span>新增对象</span>
            </div>
            <hc-input v-model="varObj.objectName"
                size="small"
                placeholder="输入对象名称搜索对象"
                @input="getGroupBykeyword"
            />
            <div ref="object-picker__wraper" class="object-picker__wraper">
                <div v-for="item in objectArr" :key="item.id" :class="{
                    'object-picker__wraper__item':true,
                    'object-picker__wraper__item--active':item.id === varObj.objectId
                }" @click.stop.prevent="selectFn(item)"
                >
                    <span>{{ item.title }}</span>
                    <img v-if="item.id === varObj.objectId" src="https://pureui-static.oss-cn-hangzhou.aliyuncs.com/paas-web/selected.svg" alt="">
                </div>
            </div>
            <div slot="footer">
                <hc-button type="plain" @click="cancelFn">
                    取消
                </hc-button>
                <hc-button type="primary" @click="saveFn()">
                    保存
                </hc-button>
            </div>
        </hc-dialog>
        <add-object :show-required="showRequired" :schema="schema" :visible.sync="showAddObject" :business-env-id="businessEnvId" :object-arr="objectArr" :api-param-obj="apiParamObj" @addObjectSuccess="addObjectSuccess" />
    </div>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import * as T from '@common/store/app-resource/types'
import debounce from 'lodash/debounce'
import { APP_RESOURCE } from '@common/store/module-types'
import AddObject from './add-object'

import commomMixin from '../mixins/commom'

export default {
    name: 'ObjectPicker',
    components: {
        AddObject,
    },
    mixins: [commomMixin],
    props: {
        title: {
            type: String,
            default: '选择对象',
        },
        value: {
            type: String,
            default: '',
        },
        objectName: {
            type: String,
            default: '',
        },
        schema: {
            type: Object,
        },
        showAddBtn: {
            type: Boolean,
            default: false,
        },
        businessEnvId: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showRequired: {
            type: Boolean,
            default: true,
        },
        apiParamObj: {
            type: Object,
        },
    },
    data() {
        return {
            page: 1,
            pageSize: 20,
            varObj: {},
            objectArr: [],
            offsetHeight: 0,
            scrollHeight: 0,
            loading: false,
            lastHeight: 0,
            showAddObject: false,
            isEnd: false,
            isRegisterEvent: false,
            scroller: null,
            currentObject: {},
            hasAppend: false,
        }
    },
    computed: {
        valueId: {
            get() {
                return (!this.objectArr.length ? '' : this.varObj.objectId)
            },
            set() {
    
            },
        },
        appInfo() {
            return this.$store.state.modeling.app
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.$set(this.varObj, 'objectId', val)
            },
        },
        'varObj.visible'(val) {
            if (val) {
                this.page = 1
                // this.objectArr = []
                this.getGroupObjectFn()
            }
            this.$nextTick(() => {
                if (val && !this.isRegisterEvent) {
                    this.isRegisterEvent = true
                    const $el = this.$refs['object-picker__wraper']
                    // 通过对象接收滚动dom, beforeDestroy里ref已经被销毁，移除不了监听器，会导致内存泄漏
                    this.scroller = $el
                    this.scrollHeight = $el.scrollHeight
                    this.offsetHeight = $el.offsetHeight
                    $el && $el.addEventListener('scroll', this.onScroll)
                }
            })
        },
    },
    async created() {
        await this.getDetailByID()
        await this.getGroupObjectFn()
    },
    beforeDestroy() {
        if (this.scroller) {
            this.scroller.removeEventListener('scroll', this.onScroll)
            this.scroller = null
        }
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getObject: T.GET_NEW_OBJECT,
            getObjectDetail: T.GET_OBJECT_DETAIL,
        }),
        addObject() {
            if (this.schema) {
                this.showAddObject = true
                return
            }
            this.$message.error('未传入schema对象！')
        },
        addObjectSuccess() {
            this.page = 1
            this.objectArr = []
            this.getGroupObjectFn()
        },
        // 对象列表
        async getGroupObjectFn() {
            this.loading = true
            try {
                const resData = await this.getObject({
                    keyword: this.varObj.objectName,
                    page: this.page,
                    pageSize: this.pageSize,
                })
                this.page += 1
                const tempData = (resData.items || []).filter(item => this.currentObject?.id !== item.id)
                // 去重
                this.objectArr = tempData.reduce((all, item) => {
                    if (all.findIndex(arr => arr.id === item.id) >= 0) return all
                    return [
                        ...all,
                        item,
                    ]
                }, _.cloneDeep(this.objectArr))
                this.loading = false
                this.isEnd = this.objectArr.length >= resData.total
            } catch (error) {
                this.loading = false
            }
        },
        // 根据业务对象ID获取对象详情
        async getDetailByID() {
            if (this.value) {
                try {
                    this.currentObject = await this.getObjectDetail({
                        id: this.value,
                    })
                    if (this.currentObject.id) {
                        this.objectArr.unshift(this.currentObject)
                        this.$emit('update:objectName', this.currentObject.title)
                    }
                } catch (error) {
                    this.$emit('update:objectName', '')
                }
            } else {
                this.$emit('update:objectName', '')
            }
        },
        getGroupBykeyword: debounce(async function () {
            this.page = 1
            this.objectArr = []
            this.loading = true
            try {
                const resData = await this.getObject({
                    keyword: this.varObj.objectName,
                    page: this.page,
                    pageSize: this.pageSize,
                })
                this.objectArr = (resData.items || []).filter(item => this.objectId !== item.id)
                this.loading = false
                this.isEnd = this.objectArr.length === resData.total
            } catch (error) {
                this.loading = false
            }
        }, 200),
        cancelFn() {
            this.$set(this.varObj, 'visible', false)
            this.$set(this.varObj, 'objectId', this.value)
        },
        selectFn(obj) {
            this.$set(this.varObj, 'objectName', obj.title)
            this.$set(this.varObj, 'objectId', obj.id)
            this.$set(this.varObj, 'objectEnName', obj.name)
        },
        saveFn() {
            this.$emit('input', this.varObj.objectId)
            this.$emit('update:objectName', this.varObj.objectName)
            this.$emit('update:objectEnName', this.varObj.objectEnName)
            this.$set(this.varObj, 'visible', false)
        },
        onScroll(e) {
            const { scrollTop } = e.target
            const now = scrollTop + this.offsetHeight
            if ((scrollTop + this.offsetHeight) >= (this.scrollHeight - 10) && !this.loading && now > this.lastHeight && !this.isEnd) {
                this.getGroupObjectFn()
            }
            this.lastHeight = now
        },
        validForm() {
        },
    },
}
</script>
<style lang="less" scoped>
    @import '../../../assets/less/var.less';
    @deep: ~'>>>';

    @{deep} .hc-dialog__header{
            background: #fff;
            height: 56px;
            border-bottom:1px solid rgba(0, 0, 0, 0.15);
            .hc-dialog__headerbtn{
                right: 20px;
                top: 18px;
            }
        }
        @{deep} .hc-dialog__body{
            padding:24px 40px 16px;
            .hc-select{
                display: block;
            }
        }
        @{deep} .hc-dialog__footer{
            .hc-button--plain{
                width: 88px;
                color:rgba(62, 67, 82, 1);
                border-radius: 4px;
            }
            .hc-button--primary{
                box-shadow:0px 2px 4px 0px rgba(0,0,0,0.15);
                border-radius: 4px;
            }
        }

    .add-btn {
        display: flex;
        color: #2A6AFF;
        align-items: center;
        cursor:pointer;
        margin-bottom: 12px;
    }
    .object-picker{
        &__body{
            height: 32px;
            line-height: 32px;
            border:1px solid #D3D8E9;
            border-radius: 4px;
            position: relative;
            box-shadow: border-box;
            padding:0 30px 0 15px;
            color:#6D7283;
            font-size: 13pxc;
            cursor: pointer;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            background: #fff;
            &.disabled {
                cursor: not-allowed;
                background: #F4F5F9;
            }
        }
        .icon-more{
            position: absolute;
            // right: 12px;
            // transform: translateY(-50%);
            transform: rotateZ(90deg);
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border-bottom: 1px solid #D3D8E9;
        }
        // &__body::after{
        //     content: '';
        //     height: 0;
        //     width: 0;
        //     border-top:6px #999 solid;
        //     border-left:4px transparent solid;
        //     border-right:4px transparent solid;
        //     position: absolute;
        //     right:12px;
        //     top: 0;
        //     bottom: 0;
        //     margin:auto;
        // }
        &__wraper{
            height: 202px;
            overflow-y: auto;
            border-radius:2px;
            border:1px solid rgba(211,216,233,1);
            margin-top:9px;
            &__item{
                height: 40px;
                color:#3E4352;
                line-height: 40px;
                padding-left:11px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;
                >span,
                >img{
                    vertical-align: middle;
                }
                >img{
                    float: right;
                    position: relative;
                    top:4px;
                }
            }
            &__item:hover,
            &__item--active{
                background:rgba(246,247,252,1);
                color:#2A6AFF;
            }
        }
        @{deep} .hc-input.is-disabled{
            .hc-input__inner{
                background: #fff;
                cursor: pointer;
            }
        }
        @{deep} .hc-input__inner{
            height: 32px;
        }
    }
</style>
